export const disaggregation_reports = {
  disaggregation_reports: {
    reports: [
      {
        location: { name: "Auckland", key: "AKL", code: "-36.87~174.77", lat: -36.87, lon: 174.77 },
        vs30: 400,
        inv_time: 50,
        poe: 0.02,
        imt: "PGA",
        report_url: "nshm-static-reports.gns.cri.nz/openquake/DATA/NSHM_v1.0.4/akl-400-pga-2",
      },
    ],
  },
};
